'use client';

import React from 'react';
import { Button } from '@/components/Button/Button';
import { ModalClose } from '@/components/Modal/BaseModal';
import { Modal } from '@/components/Modal/Modal';

type ActionWarningModalProps = {
	title: string;
	description?: string | React.ReactNode;
	children?: React.ReactNode;
	onConfirm?: () => void;
	confirmButtonLabel?: string;
	cancelButtonLabel?: string;
	modalTriggerAsChild?: boolean;
	modalTriggerChild?: React.ReactNode;
};

export const ActionWarningModal = ({
	children,
	description,
	title,
	onConfirm,
	confirmButtonLabel,
	cancelButtonLabel,
	modalTriggerAsChild,
	modalTriggerChild
}: ActionWarningModalProps) => {
	return (
		<Modal
			size="sm"
			title={title}
			description={description}
			modalTriggerAsChild={modalTriggerAsChild}
			modalTriggerChild={modalTriggerChild}
		>
			{children}
			<div className="mt-6 d-flex d-flex-column sm:d-flex-row gap-6 justify-between">
				<ModalClose asChild>
					<Button variant="secondary" className="flex-1">
						{cancelButtonLabel}
					</Button>
				</ModalClose>
				<Button className="flex-1" variant="primary" onClick={onConfirm}>
					{confirmButtonLabel}
				</Button>
			</div>
		</Modal>
	);
};
